import useTourManager from '../../hooks/useTourManager';
import { tourSteps } from '../../config/productUsageConfig';

const useProductUsageTour = ({
  isAuthenticated,
  dataReady,
  hasSeenNavbarTour
}) => {
  // Use shared tour manager
  const { startTour } = useTourManager({
    tourName: 'productUsageTour',
    cookieName: 'productUsageTourSeen',
    isAuthenticated,
    dataReady,
    hasSeenNavbarTour,
    pageSteps: tourSteps
  });

  return { startTour };
};

export default useProductUsageTour;
